import React from "react";

import loadingGIF from "assets/images/icons/loadingimg.gif";
import styled from "styled-components";

const Spinner = ({ width, height }) => {
  return (
    <SpinnerImage
      src={loadingGIF}
      alt="...loading"
      width={width}
      height={height}
    />
  );
};

export default Spinner;

const SpinnerImage = styled.img`
  display: block;
  margin: 0 auto;
  width: ${(props) => props.width || 0}px;
  height: ${(props) => props.height || 0}px;
`;
